import React from "react";
import { useCurrentUser } from "../datastores";

export type AdminGuardProps = {
  children: React.ReactNode;
};

export function AdminGuard({ children }: AdminGuardProps) {
  const isAdminQuery = useCurrentUser({
    select(response) {
      return response.data === null || response.data.admin;
    },
  });

  if (isAdminQuery.isSuccess && isAdminQuery.data) {
    return <>{children}</>;
  }

  return null;
}
